import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/home',
    redirect: '/home/1'
  },
  {
    path: '/home/:page',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiredAuth: true },
  },
  {
    path: '/question/:seq?',
    name: 'BoardQuestion',
    component: () => import('../views/Question.vue'),
    meta: { requiredAuth: true },
  },
  {
    path: '/question/:seq',
    name: 'BoardDetail',
    component: () => import('../components/BoardDetail.vue'),
    meta: { requiredAuth: true },
  },
  {
    path: '/admin',
    name: 'AdminPage',
    component: () => import('@/components/AdminPage.vue'),
    meta: { requiredAuth: true },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})
function guard(to, from, next, data) {
  if (to.meta && to.meta.requiredAuth) {
    if (data && data.id) {
      return next()
    }
    return next({ path: '/' })
  } else {
    if (data && data.id) {
      return next({ path: '/home/1' })
    }

    return next()
  }
}

router.beforeEach(async (to, from, next) => {
  let data = ''

  await store.dispatch('loadTokenFromStorage').then(() => {
    data = store.getters['getData']

    return guard(to, from, next, data)
  }),
    (err) => {
      console.log(err)
      return guard(to, from, next, data)
    }
})

export default router
